import { createContext } from 'react';

export interface IHighlightContext {
  handleSelection: () => void;
  handleHighlight: () => void;
  handleRemoveHighlight: () => void;
  currentHighlight: HTMLSpanElement | null;
  handleClickHighlight: (e: MouseEvent<HTMLDivElement, MouseEvent>) => void;
  handlerOpenNotes: () => void;
}

const HighlightContext = createContext<IHighlightContext | undefined>(undefined);
export default HighlightContext;
